import dayjs, { Dayjs } from 'dayjs';

export type RecencyStatus = 'recent' | 'stale' | 'overdue' | 'no-data';

export const RECENCY_STATUS_THRESHOLDS = {
    recentDays: 14,
    staleDays: 30,
};

export const RECENCY_STATUS_CONFIG: Record<RecencyStatus, { label: string; color: string; mapFill: string; mapLine: string }> = {
    recent: {
        label: 'Recently scanned',
        color: '#22c55e',
        mapFill: '#22c55e',
        mapLine: '#15803d',
    },
    stale: {
        label: 'Stale',
        color: '#f59e0b',
        mapFill: '#f59e0b',
        mapLine: '#b45309',
    },
    overdue: {
        label: 'Overdue',
        color: '#ef4444',
        mapFill: '#ef4444',
        mapLine: '#b91c1c',
    },
    'no-data': {
        label: 'No data',
        color: '#94a3b8',
        mapFill: '#94a3b8',
        mapLine: '#64748b',
    },
};

export const getRecencyStatus = (latestAt: Dayjs | null, now: Dayjs = dayjs()): RecencyStatus => {
    if (!latestAt) return 'no-data';
    const daysSince = now.diff(latestAt, 'day');
    if (daysSince <= RECENCY_STATUS_THRESHOLDS.recentDays) return 'recent';
    if (daysSince <= RECENCY_STATUS_THRESHOLDS.staleDays) return 'stale';
    return 'overdue';
};
